import { render, staticRenderFns } from "./IMHeader.vue?vue&type=template&id=7802f76b&"
import script from "./IMHeader.vue?vue&type=script&lang=js&"
export * from "./IMHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports